import React, { Component } from 'react'
import Popup from './Popup'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import { Form, Input, Checkbox } from 'formsy-react-components';
import { Row, Col } from 'react-bootstrap';
import './popup.css'
import { LogeButtonSlim } from '../../GeneralStyle'
import { inject } from 'mobx-react';
import { instanceOf } from 'prop-types';

import config from 'react-global-configuration';

@inject('userStore')

class FillPartnerInformationPopup extends Component {

  constructor(props) {
      super(props)
      this.state = {
        open: false,
      }

      this.openModal = this.openModal.bind(this)

  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ open: this.props.open })

      if(this.props.open && this.props.reopen)
        this.child.openModal()
    }
  }

  openModal() {
  }

  render() {

    return (
      <Popup width="400px" height="auto" ref={instance => { this.child = instance; }} open={this.state.open} onClose={this.props.onClose}>
        <Heading>Profildaten vervollständigen!</Heading>

        <Text style={{marginTop: 20}}>
          Leider haben Sie noch nicht Ihr gesamtes Profil vervollständigt - wir bitten Sie dies für die optimale Repräsantation Ihres Unternehmens zu tun.<br /><br />
          Vielen Dank!
        </Text>

        <LogeButtonSlim
          hoverFontColor={"white"}
          style={{margin: "20px 0"}}
          onClick={() => { this.props.history.push(`/partner/${this.props.userStore.company.shortname}`) }}>
            jetzt ausfüllen
        </LogeButtonSlim> <br />
        <a onClick={ () => { this.child.closeModal() }} style={{cursor: "pointer"}}>nicht jetzt</a>
      </Popup>
    )
  }
}

export default withRouter(FillPartnerInformationPopup)

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`

const Text = styled.p `
  color: black;
`



// WEBPACK FOOTER //
// /src/components/internal/Popups/FillPartnerInformationPopup.js